export const state = {
    firstTimeAccessApp: true
}

export const mutations = {
    SET_FIRST_TIME_ACCESS_APP(state, newValue) {
        state.firstTimeAccessApp = newValue
    }
}

export const getters = {
    getFirstTimeAccessApp(state){
        return state.firstTimeAccessApp;
    },
}

export const actions = {
    async setFirstTimeAccessApp({commit}, value) {
        commit("SET_FIRST_TIME_ACCESS_APP", value)
    }
}

